import script from "./SideBarOptionGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarOptionGroup.vue?vue&type=script&setup=true&lang=js"

import "./SideBarOptionGroup.vue?vue&type=style&index=0&id=082f7e92&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-082f7e92"]])

export default __exports__